import { Store } from '../core/core.js'

export default new Store({
  photo: 'https://via.placeholder.com/150',
  name: 'John Doe',
  email: 'johndoe@gmail.com',
  web: 'https://johndoe.com',
})